<template>
    <div>
        <rkm-data-table
            :fields="fields.datatables.regularizacao"
            :repository="repositories.regularizacaoCadastro"
            :filter="localFilter"
            :search-by="localSearchOption"
            :reset-table="resetTable"
            :search-table="searchTable"
            ref="RkmDataTable"
            sort-by="data"
        >
            <template v-slot:filters>
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.unidade"
                            disabled
                            label="Unidade"
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.infraestrutura"
                            disabled
                            label="Local de atendimento"
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-input
                            placeholder="Digite para buscar"
                            v-model="localFieldFilter"
                            @keyup.native.enter="handleEnterKey"
                        >
                            <rkm-input-group-prepend slot="prepend">
                                <rkm-form-select
                                    :options="searchOptions"
                                    class="m-0"
                                    v-model="localSearchOption"
                                />
                            </rkm-input-group-prepend>

                            <rkm-input-group-append slot="append">
                                <rkm-button
                                    @click="search"
                                    color="primary"
                                    class="btn-search"
                                >
                                    Buscar
                                </rkm-button>
                                <rkm-button
                                    :disabled="!localFieldFilter"
                                    @click="clear"
                                    class="btn-clear"
                                >
                                    Limpar
                                </rkm-button>
                            </rkm-input-group-append>
                        </rkm-form-input>
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-slot:cell(nome)="row">
                <rkm-button
                    class="mr-2"
                    color="secondary"
                    small
                    v-rkm-popover.hover.left="{
                        title:'Dados cadastrais',
                        html:true,
                        content: '<b>Prontuário</b>: ' + row.item.prontuario + '<br />'
                                + '<b>Data de nascimento</b>: ' + row.item.dataNascimento + '<br />'
                                + '<b>Nome da mãe</b>: ' + row.item.nomeMae + '<br />'
                        }"
                >
                    <rkm-icon icon="user" />
                </rkm-button>

                <span v-if="!row.item.sequencialDesconhecido">
                    {{ row.item.nome }}
                </span>

                <span
                    v-else
                    class="text-primary"
                    v-rkm-popover.hover.top="{
                        title:'Características físicas',
                        container: 'body',
                        content: row.item.caracteristicasFisicas
                    }"
                >
                    {{ row.item.nome}}
                </span>
            </template>

            <template v-slot:cell(actions)="row">
                <rkm-button
                    @click.stop="$refs.ModalPacienteCadastroSimplificado.open(row.item.id)"
                    authorize="store-pronto-atendimento-regularizacao-cadastro"
                    color="primary"
                    :disabled="handleEdit(row.item)"
                    small
                    title="Regularizar cadastro"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>
            </template>
        </rkm-data-table>

        <ModalPacienteCadastroSimplificado
            @save="save"
            ref="ModalPacienteCadastroSimplificado"
        />
    </div>
</template>

<script>
// Components.
import ModalPacienteCadastroSimplificado from '@/components/cadastro/paciente/components/cadastro-simplificado/Modal'

// Mixins.
import { error, repository } from '@/mixins'

// Vuex.
import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'

// Enums.
import classificacao from '@/enums/cadastro/paciente/classificacao'

export default {
    components: { ModalPacienteCadastroSimplificado },
    computed: {
        ...mapGetters({ lotacao: 'getLotacao' }),
        fields() {
            return {
                datatables: {
                    regularizacao: [
                        {
                            key: 'data',
                            label: 'Data',
                            name: 'data',
                            searchable: true,
                            sortable: true,
                        },
                        {
                            key: 'faaId',
                            label: 'FAA',
                            name: 'faa.id',
                            searchable: true,
                            sortable: true,
                        },
                        {
                            key: 'sexo',
                            label: 'Sexo',
                            name: 'sexo.descricao',
                            searchable: true,
                            sortable: true,
                        },
                        {
                            key: 'nome',
                            label: 'Paciente',
                            name: 'cidadao.nome',
                            searchable: true,
                            sortable: true,
                        },
                        {
                            class: 'col-min text-center',
                            key: 'actions',
                            label: 'Ações',
                        },
                    ],
                },
            }
        },
        searchOptions() {
            return this.fields.datatables.regularizacao.filter(field => !!field.searchable).map(field => {
                return { text: field.label, value: field.key }
            })
        },
    },
    created() {
        this.repositories = {
            regularizacaoCadastro: this.getConectaSusRepository('prontoAtendimento.regularizacaoCadastro')
        }
    },
   data: () => ({
        localFieldFilter: null,
        localFilter: null,
        localSearchOption: 'nome',
        resetTable: false,
        searchTable: false,
        form: {
            unidade: [],
            infraestrutura: [],
            isPermissaoCadastro: null,
            isNotParametrizado: null,
        },
        model: {
            unidadeId: null,
            infraestruturaId: null,
            filter: null,
        },
        enums: { classificacao }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.form.unidade =  [{
                id: this.lotacao.infraestrutura.unidade.id,
                nomeFantasia: this.lotacao.infraestrutura.unidade.nomeFantasia,
            }]

            this.form.infraestrutura = [{
                id: this.lotacao.infraestrutura.id,
                nome: this.lotacao.infraestrutura.nome,
            }]

            this.model.unidadeId = this.lotacao.infraestrutura.unidade.id
            this.model.infraestruturaId = this.lotacao.infraestrutura.id

            this.permissao()
        },
        permissao() {

            this.setLoading()

            this.repositories.regularizacaoCadastro.index()
                .then(({ data }) => {

                    this.form.isPermissaoCadastro = data.classificacoes.length > 0 || data.isPermissaoCadastro ? true : false
                    this.form.isNotParametrizado = data.isPermissaoCadastro ? true : false
                    this.form.classificacoes = data.classificacoes
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.RkmDataTable.refresh()
        },
        search() {
            this.searchTable = true
            this.resetTable = false
            this.localFilter = this.localFieldFilter
            this.$refs.RkmDataTable.refresh();
        },
        clear() {
            this.localSearchOption = 'nome';
            this.clearSearchOption()
        },
        clearSearchOption() {
            this.localFieldFilter = null
            this.clearTable()
        },
        clearTable() {
            this.localFilter = null
            this.resetTable = true
            this.searchTable = false
        },
        handleEnterKey(event) {

            if (event.key === 'Enter') {
                this.search();
            }
        },
        handleEdit(item) {

            if (!this.form.isPermissaoCadastro) {
                return true;
            }

            if (this.form.isNotParametrizado) {
                return false;
            }

            if (!item.classificacaoId && this.form.classificacoes.length > 0) {
                return false;
            }

            const classificacoes = this.form.classificacoes;
            const classificacaoId = item.classificacaoId;

            const isClassificacaoPresent = (classificacaoId) => {
                return classificacoes.some(classificacao => classificacao.id === classificacaoId);
            };

            switch (classificacaoId) {
                case this.enums.classificacao.MUNICIPE:
                case this.enums.classificacao.PROVISORIO:
                case this.enums.classificacao.OUTRO_MUNICIPIO:
                    return !isClassificacaoPresent(classificacaoId);
                default:
                    return false;
            }
        }
    },
    mixins: [ error, repository ],
    mounted() {

        if (this.searchOptions.length > 0) {
            this.localSearchOption = 'nome';
        }

        this.load()
    },
    watch: {
        filter(value) {
            this.localFilter = value
        },
        'localSearchOption': function () {

            this.clearSearchOption()
        },
        'localFieldFilter': function () {

            this.clearTable()
        },
    },
}
</script>

<style scoped>
.btn-search {
    border-top-right-radius: 0.25rem!important;
    border-bottom-right-radius: 0.25rem!important;
}
.btn-clear {
    border-top-left-radius: 0.25rem!important;
    border-bottom-left-radius: 0.25rem!important;
}
</style>